module.exports = __webpack_public_path__ + "img/not-found.303470ba.png";